import { c as _c } from "react/compiler-runtime";
import { HStack, Icon, Text } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { Article, ContentTrackSection, ContentTrackStep, PodcastEpisode } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React from 'react';
import { AiFillAudio } from 'react-icons/ai';
import { BiGlasses } from 'react-icons/bi';
import { LuListTodo } from 'react-icons/lu';
import { PiMonitorPlayBold } from 'react-icons/pi';
type SectionStepProgressBar = {
  contentTrackSection: ContentTrackSection;
  contentTrackStep: ContentTrackStep;
};
export const SectionStepProgressBar = props => {
  const $ = _c(27);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const video = props.contentTrackStep.video;
  let T0;
  let podcastEpisode;
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== getBreakpointValue || $[1] !== props.contentTrackStep.contentAttachments) {
    const article = props.contentTrackStep.contentAttachments.find(_temp) as Article;
    let t4;
    if ($[8] !== props.contentTrackStep.contentAttachments) {
      t4 = props.contentTrackStep.contentAttachments.find(_temp2);
      $[8] = props.contentTrackStep.contentAttachments;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    podcastEpisode = t4 as PodcastEpisode;
    T0 = HStack;
    t0 = "flex-start";
    t1 = "4";
    t2 = "flex-end";
    t3 = article && <HStack gap="0.5em"><Icon asChild={true} boxSize={4}><BiGlasses /></Icon><Text opacity="0.7" textStyle={getBreakpointValue(["labelXs", "labelXs", "labelSm"])}>{Math.round(article.body && article.body.split(" ").length / 230)}m Read</Text></HStack>;
    $[0] = getBreakpointValue;
    $[1] = props.contentTrackStep.contentAttachments;
    $[2] = T0;
    $[3] = podcastEpisode;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    T0 = $[2];
    podcastEpisode = $[3];
    t0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[10] !== getBreakpointValue || $[11] !== video) {
    t4 = video && <HStack><Icon asChild={true} boxSize={4}><PiMonitorPlayBold /></Icon><Text textStyle={getBreakpointValue(["labelXs", "labelXs", "labelSm"])}>{(video.playbackEndInSeconds - video.playbackStartInSeconds || video.playbackDurationInSeconds) > 0 && <>{Math.round((video.playbackEndInSeconds - video.playbackStartInSeconds || video.playbackDurationInSeconds) / 60)}{"m"}{" "}</>}Watch</Text></HStack>;
    $[10] = getBreakpointValue;
    $[11] = video;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== getBreakpointValue || $[14] !== podcastEpisode) {
    t5 = podcastEpisode && <HStack><Icon asChild={true}><AiFillAudio /></Icon><Text textStyle={getBreakpointValue(["labelXs", "labelXs", "labelSm"])}>{false && <>Xm</>} Listen</Text></HStack>;
    $[13] = getBreakpointValue;
    $[14] = podcastEpisode;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== props.contentTrackStep.tasks) {
    t6 = props.contentTrackStep.tasks && props.contentTrackStep.tasks.length > 0 && <HStack><Icon asChild={true}><LuListTodo /></Icon><Text>{props.contentTrackStep.tasks.length} Tasks</Text></HStack>;
    $[16] = props.contentTrackStep.tasks;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== T0 || $[19] !== t0 || $[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6) {
    t7 = <T0 alignContent={t0} gap={t1} justify={t2}>{t3}{t4}{t5}{t6}</T0>;
    $[18] = T0;
    $[19] = t0;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
};
SectionStepProgressBar.fragments = {
  Article: () => gql`
    fragment _ on Article {
      id
      title
      body
    }
  `,
  PodcastEpisode: () => gql`
    fragment _ on PodcastEpisode {
      id
      title
      # durationInSeconds
    }
  `,
  ContentTrackStep: () => gql`
    fragment _ on ContentTrackStep {
      id
      contentAttachments {
        __typename
        ${SectionStepProgressBar.fragments.Article()}
        ${SectionStepProgressBar.fragments.PodcastEpisode()}
      }
      video {
        id
        playbackDurationInSeconds
        playbackEndInSeconds
        playbackStartInSeconds
      }
      tasks {
        id
      }
    }
  `
};
function _temp(a) {
  return a.__typename === "Article";
}
function _temp2(a_0) {
  return a_0.__typename === "PodcastEpisode";
}